module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAaBAMAAAA+iaOCAAAAJFBMVEUAAAA6l/c6l/c6l/c6l/c6l/c6l/c6l/c6l/c6l/c6l/c6l/euPLACAAAAC3RSTlMAIhHr4/Tn31ZNRcxpmccAAABKSURBVCjPY1iyGwvwYqjGJrydIRub8GaGVmzCEQwMglgAw4AAJSyAgWEyNndbMnhjE96GQxiHIbispD/AEQ04Ig1HFONIEDiSDwDrhcMZkOhsqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/phone/List.png
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22